import script from "./KpiGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiGrid.vue?vue&type=script&setup=true&lang=js"

import "./KpiGrid.vue?vue&type=style&index=0&id=2cb9a188&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb9a188"]])

export default __exports__